import type { SoftphoneClient, SoftphoneMediaStrategy, SoftphoneProvider } from './softphoneClient.types';
import { JustCallSoftphoneClient } from './justcallSoftphoneClient';
import { TelnyxSoftphoneClient } from './telnyxSoftphoneClient';
import { TwilioSoftphoneClient } from './twilioSoftphoneClient';

/**
 * Pick the browser softphone client for a carrier. Both surfaces (dashboard + extension)
 * call this with the team's provider, so switching carriers is a server-config change the
 * client adapts to — no per-surface forks. JustCall ignores the media strategy: its own dialer
 * (an iframe) captures the mic.
 */
export function createSoftphoneClient(
  provider: SoftphoneProvider,
  mediaStrategy?: SoftphoneMediaStrategy,
): SoftphoneClient {
  if (provider === 'justcall') return new JustCallSoftphoneClient();
  return provider === 'twilio'
    ? new TwilioSoftphoneClient(mediaStrategy)
    : new TelnyxSoftphoneClient(mediaStrategy);
}
